"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isReservedShowing = exports.ShowingTypes = void 0;
exports.ShowingTypes = {
    personal: 'personal',
    openHouse: 'openHouse'
};
/** type guard so we can use showing.applicationIds, also allows us to easily check if showing is reserved */
exports.isReservedShowing = function (showing) {
    return showing.applicationIds !== undefined;
};
//# sourceMappingURL=showings.js.map